import moment from "moment";

export const countDate = (date: string) => {
  return moment
    .duration(moment(new Date(), "YYYY-MM-DD").diff(moment(date, "YYYY-MM-DD")))
    .asDays()
    .toFixed();
};
